
const Personalinfo = () => {

    return (
        <div class="lively-card height400">
        <p class="text-small"> 
             <strong>Phone</strong><br/>
             94 70 50 3300
             <br/><br/>

             <strong>Email</strong><br/>
             surendramehta35@yahoo.co.in 
             <br/><br/>

             <strong>Address</strong><br/>
					Bali Complex, <br/> 
            Near Royal Enfield Showroom, <br/> 
            V.B.U<br/> 
            Sindoor, NH-33, <br/>
            Hazaribag <br/>
            Jharkhand-825301<br/><br/>
		</p>
        </div>
    );
}

export default Personalinfo;